import { CheckoutCartResponse } from '_app/graphql/types'
import {
  Maybe,
  AvailableShippingMethod,
  SelectedShippingMethod,
  Cart,
  ShippingCartAddress,
} from '_app/types/api'

const checkIfMethodIsAvailable = (
  availableMethods: Maybe<AvailableShippingMethod>[],
  selectedShippingMethod: SelectedShippingMethod
) => {
  return availableMethods.some(
    method => method?.method_code === selectedShippingMethod?.method_code
  )
}

export const getSelectedShippingMethod = (
  data: any
) => {
  const availableMethods =
    data?.cart?.shipping_addresses?.[0]?.available_shipping_methods || []
  const selectedShippingMethod =
    data?.cart?.shipping_addresses?.[0]?.selected_shipping_method
  if (
    selectedShippingMethod &&
    checkIfMethodIsAvailable(availableMethods, selectedShippingMethod)
  ) {
    return selectedShippingMethod
  }

  return undefined
}

export const getDefaultShippingMethodForm = (
  data: any
): Cart | undefined => {
  if (!data?.cart) return undefined
  const shippingAddresses = [...(data.cart.shipping_addresses || [])]

  if (!shippingAddresses[0]?.selected_shipping_method) {
    return data.cart
  }

  if (
    checkIfMethodIsAvailable(
      shippingAddresses[0]?.available_shipping_methods || [],
      shippingAddresses[0].selected_shipping_method
    )
  ) {
    return data.cart
  }

  return {
    ...data.cart,
    shipping_addresses: shippingAddresses.map(
      address =>
        ({
          ...address,
          selected_shipping_method: undefined,
        } as Maybe<ShippingCartAddress>)
    ),
  }
}
